/* Shared review metrics. Zero until real reviews exist (review app). */
window.STORE = window.STORE || {};
STORE.reviewStats = { average: null, total: 0, fiveStar: 0 };
